var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconalertas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.126,
    height: 33.677,
    viewBox: "0 0 38.126 33.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_alertas",
    "data-name": "icon alertas",
    transform: "translate(-40.568 -7.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32488",
    "data-name": "Caminho 32488",
    d: "M76.485,36.689,60.926,10.012a1.5,1.5,0,0,0-2.591,0L42.777,36.689a1.5,1.5,0,0,0,1.3,2.256H75.188a1.5,1.5,0,0,0,1.3-2.256ZM62.655,9a3.5,3.5,0,0,0-6.047,0L41.049,35.681a3.5,3.5,0,0,0,3.024,5.263H75.188a3.5,3.5,0,0,0,3.024-5.263ZM59.381,18.07a1.25,1.25,0,0,1,1.25,1.25v11.5a1.25,1.25,0,1,1-2.5,0V19.32a1.25,1.25,0,0,1,1.25-1.25Zm0,17.75a1.25,1.25,0,1,0-1.25-1.25A1.25,1.25,0,0,0,59.381,35.82Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconalertas);
export default __webpack_public_path__ + "static/media/icon alertas.3eef4b8aaa2a965d4f0a06c6dd4286bb.svg";
export { ForwardRef as ReactComponent };